/**
 * FamiliarisationNADialog - N/A reason selection dialog
 */

import React, { useState, useEffect } from 'react';

const FamiliarisationNADialog = ({
  show,
  item,
  selectedNAReason,
  onReasonChange,
  onConfirm,
  onCancel
}) => {
  const [customReason, setCustomReason] = useState('');
  const [showCustomInput, setShowCustomInput] = useState(false);
  const [internalReason, setInternalReason] = useState('');

  useEffect(() => {
    if (!show) {
      setCustomReason('');
      setShowCustomInput(false);
      setInternalReason('');
    }
  }, [show]);

  if (!show) return null;

  const getNAReasons = () => [
    { value: 'not_required_rank', label: 'Not required by rank/role' },
    { value: 'equipment_not_onboard', label: 'Equipment not onboard' },
    { value: 'not_applicable_vessel', label: 'Not applicable to this vessel type' },
    { value: 'system_not_installed', label: 'System not installed' },
    { value: 'electric_propulsion', label: 'Electric propulsion vessel' },
    { value: 'no_passenger_ops', label: 'No passenger operations' },
    { value: 'no_cargo_ops', label: 'No cargo/lifting operations' },
    { value: 'open_deck_only', label: 'Open deck vessel only' },
    { value: 'not_required_category', label: 'Not required for vessel category' },
    { value: 'other', label: 'Other (please specify)' }
  ];

  const handleReasonChange = (value) => {
    setInternalReason(value);
    if (value === 'other') {
      setShowCustomInput(true);
      onReasonChange?.('other');
    } else {
      setShowCustomInput(false);
      setCustomReason('');
      onReasonChange?.(value);
    }
  };

  const handleConfirm = () => {
    const reason = selectedNAReason || internalReason;
    if (reason === 'other' && customReason.trim()) {
      onConfirm(`other: ${customReason.trim()}`);
    } else if (reason && reason !== 'other') {
      onConfirm(reason);
    }
  };

  return (
    <div className="fixed inset-0 z-60 overflow-y-auto">
      <div className="fixed inset-0 bg-black bg-opacity-50" onClick={onCancel} />
      <div className="relative min-h-screen flex items-center justify-center p-4">
        <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full">
          <div className="px-6 py-4 border-b border-gray-200">
            <h3 className="text-lg font-semibold text-gray-900">N/A Reason Required</h3>
            <p className="text-sm text-gray-600 mt-1">
              {item?.text}
            </p>
          </div>
          
          <div className="p-6">
            <label className="block text-sm font-medium text-gray-700 mb-3">
              Please select why this item is not applicable:
            </label>
            <div className="space-y-2">
              {getNAReasons().map((reason) => (
                <label key={reason.value} className="flex items-center">
                  <input
                    type="radio"
                    name="naReason"
                    value={reason.value}
                    checked={(selectedNAReason || internalReason) === reason.value}
                    onChange={(e) => handleReasonChange(e.target.value)}
                    className="h-4 w-4 text-cyan-600 border-gray-300 focus:ring-cyan-500"
                  />
                  <span className="ml-3 text-sm text-gray-900">{reason.label}</span>
                </label>
              ))}
            </div>
            
            {showCustomInput && (
              <div className="mt-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Please specify the reason:
                </label>
                <textarea
                  value={customReason}
                  onChange={(e) => setCustomReason(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-cyan-500 focus:border-cyan-500"
                  rows={3}
                  placeholder="Enter your custom reason..."
                  autoFocus
                />
              </div>
            )}
          </div>
          
          <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex items-center justify-end gap-3">
            <button
              onClick={onCancel}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              onClick={handleConfirm}
              disabled={!(selectedNAReason || internalReason) || ((selectedNAReason || internalReason) === 'other' && !customReason.trim())}
              className="px-4 py-2 text-sm font-medium text-white bg-cyan-600 border border-transparent rounded-md hover:bg-cyan-700 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Confirm N/A
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FamiliarisationNADialog;